var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.753H6.72A2.558 2.558 0 0 1 4.165 8.2a2.558 2.558 0 0 1 2.553-2.553h4.514c.273 0 .5.226.5.5 0 .273-.227.5-.5.5H6.719c-.853 0-1.553.693-1.553 1.553s.693 1.553 1.553 1.553H10c.274 0 .5.227.5.5 0 .274-.226.5-.5.5Z",
    fill: "#73777A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.287 7.68a.495.495 0 0 1-.353-.147.503.503 0 0 1 0-.706l.693-.694-.693-.693a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.046 1.047a.503.503 0 0 1 0 .707l-1.046 1.046a.524.524 0 0 1-.354.147Z",
    fill: "#73777A"
  })));
};
export default SvgForward;